// extracted by mini-css-extract-plugin
export default {"container":"edit-telestration_container__uTZ+f","accent":"edit-telestration_accent__cnqAE"};